import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { MatPaginatorModule } from '@angular/material/paginator';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FooterComponent } from './core/components/footer/footer.component';
import { HeaderComponent } from './core/components/header/header.component';
import { AlertComponent } from './core/components/alert/alert.component';
import { DatePipe } from '@angular/common';
import { registerLocaleData } from '@angular/common';
import localePtBr from '@angular/common/locales/pt';
import { AuthInterceptor } from './core/auth.interceptor';
import { ErrorInterceptor } from './core/error.interceptor';
import { SpinnerComponent } from './core/components/spinner/spinner.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CookieConsentComponent } from './core/components/cookie-consent/cookie-consent.component';
import { AnalyticsInitializerService } from './core/services/google-analytics/analytics-initializer.service';
import { ChargeInterceptor } from './core/charge.interceptor';
import { HeaderCearaComponent } from "./core/components/header-ceara/header-ceara.component";
import { MetaPixelInitializerService } from './core/services/meta-pixel/meta-pixel-initializer.service';

registerLocaleData(localePtBr);

export function analyticsInitFn(service: AnalyticsInitializerService) {
  return () => service.init();
}

export function metaPixelInitFn(service: MetaPixelInitializerService) {
  return () => service.init();
}

@NgModule({
  declarations: [
    AppComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FooterComponent,
    CookieConsentComponent,
    HeaderComponent,
    AlertComponent,
    SpinnerComponent,
    BrowserAnimationsModule,
    MatPaginatorModule,
    HeaderCearaComponent
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    DatePipe,
    {
      provide: LOCALE_ID,
      useValue: 'pt-BR'
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ChargeInterceptor,
      multi: true
    },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: analyticsInitFn,
      deps: [AnalyticsInitializerService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: metaPixelInitFn,
      deps: [MetaPixelInitializerService],
      multi: true
    }
  ]
})
export class AppModule { }
